import React from "react";
import { Trans } from "react-i18next";

import Slider from "react-slick";

import ProductTags from "../../components/Tags/ProductTags";
import { GLOBAL_ID } from "../../utils/constants";
import { handleExternalLink } from "../../utils/ExternalLinksHelper";

const LabsSlider = ({ labs, sliderSettings, selected, setSelected }) => {
    return (
        <>
            <Slider {...sliderSettings}>
                {labs &&
                    labs.map((lab, index) => {
                        return (
                            <div className="slider-items" key={index}>
                                <div
                                    className={`card-table mr-3 shadow ${
                                        selected === index ? "selected" : ""
                                    }`}
                                    onClick={() =>
                                        setSelected(
                                            index === selected ? null : index
                                        )
                                    }
                                >
                                    <div className="flex justify-between w-full mb-3">
                                        <div className="flex">
                                            <div className="img-with-circle">
                                                <img
                                                    src={
                                                        lab.image ||
                                                        require("../../assets/images/org-avatar.png")
                                                            .default
                                                    }
                                                    alt="AgricultureImage"
                                                />
                                            </div>

                                            <div className="text-left">
                                                <h4 className="font-semibold capitalize">
                                                    {lab.name}
                                                </h4>
                                                <div className="text-xxs text-dark-gray">
                                                    <span
                                                        className={
                                                            lab.country
                                                                ?.value ===
                                                            GLOBAL_ID
                                                                ? "fas fa-globe-americas"
                                                                : `flag-icon flag-icon-${lab.country?.alpha2Code?.toLowerCase()} mr-1`
                                                        }
                                                    ></span>
                                                    {lab.country?.label}
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <span
                                                className={`ml-2 text-sm text-primary-blue cursor-pointer ${
                                                    lab?.website
                                                        ? ""
                                                        : "disabled"
                                                }`}
                                                onClick={() =>
                                                    handleExternalLink(
                                                        lab?.website
                                                    )
                                                }
                                            >
                                                <i className="fas fa-external-link-alt" />
                                            </span>
                                        </div>
                                    </div>

                                    <div
                                        className="pl-1"
                                        // style={{ minHeight: "78px" }}
                                    >
                                        <div className="tags">
                                            <h4 className="uppercase text-xs">
                                                <Trans i18nKey="industries">
                                                    Industries
                                                </Trans>
                                            </h4>
                                            <ul className="tags-wrapper rating-section flex items-center flex-wrap">
                                                <ProductTags
                                                    tags={lab.industries}
                                                />
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </Slider>
        </>
    );
};

export default LabsSlider;
